import { useEffect, useLayoutEffect, useState } from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import { ArrowRight, Menu, X } from 'lucide-react'
import { CookieBanner } from './CookieBanner'
import { FloatingActions } from './FloatingActions'
import { mainNavigation } from '../navigation'
import { trackPage, trackLink } from '../analytics'
import { applyPageSeo } from '../seo'

export function Layout() {
  const [open, setOpen] = useState(false)
  const location = useLocation()

  // Commit the page title and tracker context before child form effects run.
  useLayoutEffect(() => {
    applyPageSeo(location.pathname)
    trackPage(location.pathname)
  }, [location.pathname])

  useEffect(() => {
    setOpen(false)
    const target = location.hash ? document.getElementById(location.hash.slice(1)) : null
    if (target) target.scrollIntoView()
    else window.scrollTo({ top: 0, behavior: 'instant' })
  }, [location.pathname, location.hash])

  useEffect(() => {
    const chosen = () => trackPage(window.location.pathname)
    window.addEventListener('analytics-choice', chosen)
    document.addEventListener('click', trackLink, true)
    document.addEventListener('auxclick', trackLink, true)
    return () => {
      window.removeEventListener('analytics-choice', chosen)
      document.removeEventListener('click', trackLink, true)
      document.removeEventListener('auxclick', trackLink, true)
    }
  }, [])

  return (
    <div className={`site-shell${location.pathname === '/' ? ' home-page' : ' content-page'}${location.pathname === '/enquiry' ? ' enquiry-page' : ''}`}>
      <div className="safety-bar"><span aria-hidden="true">●</span> Not an emergency service. In an emergency, contact local emergency services now.</div>
      <header className="site-header">
        <Link to="/" className="brand" aria-label="China Care home">
          <img className="brand-mark" src="/brand/china-care-embrace.svg" alt="" width="37" height="34" />
          <span>China Care</span>
        </Link>
        <nav className={open ? 'main-nav is-open' : 'main-nav'} aria-label="Main navigation">
          {mainNavigation.map(([label, path]) => <NavLink key={path} to={path}>{label}</NavLink>)}
          <Link className="button button-small" to="/enquiry">Start Your Enquiry <ArrowRight size={15} /></Link>
        </nav>
        <button className="menu-toggle" aria-expanded={open} aria-label="Toggle navigation" onClick={() => setOpen((value) => !value)}>
          {open ? <X /> : <Menu />}
        </button>
      </header>
      <main id="main-content"><Outlet /></main>
      <footer className="site-footer">
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} China Care</span>
          <nav className="footer-legal" aria-label="Legal"><Link to="/privacy">Privacy</Link><Link to="/terms">Terms</Link><Link to="/disclaimer">Medical disclaimer</Link></nav>
        </div>
      </footer>
      <FloatingActions key={location.pathname} />
      <CookieBanner />
    </div>
  )
}
